import { IDocumentData } from '@app/transactions/components/upload-document/upload-document.component';

export const upload_user_document_model: Array<IDocumentData> = [
    {
        document_type: 'id',
        title: {
            pending: 'Tu documentación está en revisión.',
            approved: 'Tu documentación fue aprobada.',
            default: 'Sube las fotos de tu documentación.'
        },
        why_go_up: `<p>De esta manera, nos ayudas a verificar y respaldar que eres el titular de la cuenta con la que envías tu saldo.</p>`,
        documents_qty_min: 2,
        documents_qty_max: 5,
        gif: '/assets/images/user-info/video-images-v2.gif',
        examples_document: [
            {
                url: '/assets/images/user-info/document/document-1-v3',
                urlFullScreen: '',
                condition: 'permitted'
            },
            {
                url: '/assets/images/user-info/document/document-2-v3',
                urlFullScreen: '',
                condition: 'permitted'
            },
            {
                url: '/assets/images/user-info/document/document-3-v3',
                urlFullScreen: '',
                condition: 'restricted'
            },
            {
                url: '/assets/images/user-info/document/document-4-v3',
                urlFullScreen: '',
                condition: 'restricted'
            },
            {
                url: '/assets/images/user-info/document/document-5-v3',
                urlFullScreen: '',
                condition: 'restricted'
            },
            {
                url: '/assets/images/user-info/document/document-6-v3',
                urlFullScreen: '',
                condition: 'restricted'
            },
            {
                url: '/assets/images/user-info/document/document-7-v3',
                urlFullScreen: '',
                condition: 'restricted'
            },
            {
                url: '/assets/images/user-info/document/document-8-v3',
                urlFullScreen: '',
                condition: 'restricted'
            }
        ]
    },
    {
        document_type: 'selfie',
        title: {
            pending: 'Tu selfie está en revisión.',
            approved: 'Tu selfie fue aprobada.',
            default: 'Agrega tu selfie.'
        },
        why_go_up: `<p>Esto nos ayuda a verificar tu identidad y mantener la seguridad en la plataforma.</p>`,
        documents_qty_min: 1,
        documents_qty_max: 5,
        gif: '',
        examples_document: [
            {
                url: '/assets/images/user-info/selfie/selfie-1-v2',
                urlFullScreen: '',
                condition: 'permitted'
            },
            {
                url: '/assets/images/user-info/selfie/selfie-2-v2',
                urlFullScreen: '',
                condition: 'restricted'
            },
            {
                url: '/assets/images/user-info/selfie/selfie-3-v2',
                urlFullScreen: '',
                condition: 'restricted'
            },
            {
                url: '/assets/images/user-info/selfie/selfie-4-v2',
                urlFullScreen: '',
                condition: 'restricted'
            },
            {
                url: '/assets/images/user-info/selfie/selfie-5-v2',
                urlFullScreen: '',
                condition: 'restricted'
            },
            {
                url: '/assets/images/user-info/selfie/selfie-6-v2',
                urlFullScreen: '',
                condition: 'restricted'
            },
            {
                url: '/assets/images/user-info/selfie/selfie-7-v2',
                urlFullScreen: '',
                condition: 'restricted'
            }
        ]
    },
    {
        document_type: 'form',
        title: 'Sube algunas fotos del formulario',
        why_go_up: `<li>Imprime el <a target="_blank" class="rs-link" href="https://panel.saldo.com.ar/img/validacion2/carta-aceptacion-de-pago.pdf">formulario de aceptación de pago</a>.</li>
            <li>Complétalo a mano con bolígrafo azul, verde o rojo.</li>
            <li>Pon la 1º cara de tu identificación en el lugar indicado y tomas unas fotografías.</li>
            <li>Pon la 2º cara de tu identificación en el lugar indicado y tomas nuevamente unas fotografías más.</li>`,
        documents_qty_min: 2,
        documents_qty_max: 5,
        gif: '',
        examples_document: [
            {
                url: '/assets/images/user-info/form/form-1',
                urlFullScreen: '',
                condition: 'permitted'
            },
            {
                url: '/assets/images/user-info/form/form-2',
                urlFullScreen: '',
                condition: 'permitted'
            },
            {
                url: '/assets/images/user-info/form/form-3',
                urlFullScreen: '',
                condition: 'restricted'
            },
            {
                url: '/assets/images/user-info/form/form-4',
                urlFullScreen: '',
                condition: 'restricted'
            },
            {
                url: '/assets/images/user-info/form/form-5',
                urlFullScreen: '',
                condition: 'restricted'
            },
            {
                url: '/assets/images/user-info/form/form-6',
                urlFullScreen: '',
                condition: 'restricted'
            },
            {
                url: '/assets/images/user-info/form/form-7',
                urlFullScreen: '',
                condition: 'restricted'
            }
        ]
    },
    {
        document_type: 'facebook',
        title: 'Antes de continuar, agréganos a Facebook.',
        why_go_up: `<p>Este proceso nos permite validar tu usuario y comunicarnos rápidamente a través del chat, en caso que sea necesario.</p>
        <li>Utiliza tu perfil personal, ingresa a nuestro perfil y agréganos como amigo.</li>
        <li>Envíanos un mensaje como este: <b>Hola, mi pedido en saldo es: *********</b>.</li>`,
        documents_qty_min: 2,
        documents_qty_max: 5,
        gif: '',
        examples_document: []
    }
];
